import {Box, Slide, useScrollTrigger} from '@mui/material';
import {BoxProps} from '@jobseeker/lotus/foundations';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {useEffect, useState} from 'react';
import {handleTracking} from '@jobseeker/common-core/utils';
import {AppState} from '@jobseeker/common-core/types';
import {shallowEqual, useSelector} from 'react-redux';
import cookie from 'cookie';
import {useWrappedTheme} from '@jobseeker/lotus/hooks/common';

import type {Theme} from '@mui/material';

function hashCode(str: string) {
  let hash = 0,
    i,
    chr;
  if (str?.length === 0) return hash;
  for (i = 0; i < str?.length; i++) {
    chr = str?.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}

type FloatingApplyButtonProps = {
  theme: Theme;
  style: BoxProps;
  disabled?: boolean;
  onApply?: () => string | void;
};

const FloatingApplyButton = ({
  theme,
  style = {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  disabled,
  onApply,
}: FloatingApplyButtonProps) => {
  const wrappedTheme = useWrappedTheme();
  const [cookieValue, setCookieValue] = useState('');

  useEffect(() => {
    const cookies = cookie.parse(document.cookie);
    const myCookieValue = cookies['PHPSESSID'];
    setCookieValue(myCookieValue);
  }, []);

  const PHPSESSID = Math.abs(hashCode(cookieValue)) % 2;

  sessionStorage.setItem('phpSessId', String(PHPSESSID));
  const ABTesting = PHPSESSID === 1;

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const sendEvent = (action: string) => {
    handleTracking(`Floating_Apply_Btn_${action}`, {
      event_category: 'Floating_Apply_Button',
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
      Php_SessionID_Mod: sessionStorage.getItem('phpSessId') || '0',
    });
  };

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 50,
  });

  if (disabled) return null;

  return (
    <Slide in={trigger} direction="up">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          position: 'fixed',
          bottom: '25px',
          width: '92%',
          zIndex: 12,
        }}
      >
        <Button
          sx={{
            fontSize: wrappedTheme.typography.pxToRem(18),
            fontWeight: '500',
            width: {md: '125px'},
            background: '#000',
            mt: {xxs: 1, md: 2},
            px: 4,
            py: 1,
            height: 'fit-content',
            backgroundColor: 'secondary.main',
          }}
          variant="contained"
          size="small"
          onClick={() => {
            sendEvent('Click');
            onApply && onApply();
          }}
          data-testid="floating_Apply_cta"
        >
          Apply
        </Button>
      </Box>
    </Slide>
  );
};

export default FloatingApplyButton;
